export function get_stored_user() {
  const possible_keys = [
    "user",
    "auth_user",
    "current_user",
    "pending_user_data"
  ];
  const stored_value = possible_keys
    .map((key) => sessionStorage.getItem(key) || localStorage.getItem(key))
    .find(Boolean);

  if (!stored_value) {
    return null;
  }

  try {
    return JSON.parse(stored_value);
  } catch {
    return null;
  }
}

function get_role_candidates(user) {
  return [
    user?.user_role?.role?.name,
    user?.role?.role?.name,
    user?.role?.name,
    user?.role_type,
    user?.role
  ];
}

export function get_user_role_name(user) {
  return get_role_candidates(user).find(Boolean) || "";
}

export function is_admin_user(user) {
  const role_name = String(get_user_role_name(user) || sessionStorage.getItem("role") || "").toLowerCase();

  return Boolean(
    user?.is_superuser === true ||
    user?.is_staff === true ||
    role_name === "admin" ||
    role_name === "administrator"
  );
}

export default is_admin_user;
